import React, { useEffect, useState, useCallback, useRef } from 'react';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { parsePhoneNumberFromString } from "libphonenumber-js";
import { useNavigate, useLocation } from 'react-router-dom';
import PhoneNumberField from '../../../common/PhoneNumberField';
import {
    TextField,
    FormControl,
    FormLabel,
    Box,
    Button,
    MenuItem,
    Select,
    RadioGroup,
    FormControlLabel,
    Radio,
    Dialog,
    DialogTitle,
    DialogContent,
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    DialogActions
} from '@mui/material';
import { useTheme, useMediaQuery } from '@mui/material';
import DatePickerField from '../../../common/DatePickerDashboard';
import { useDispatch, useSelector } from 'react-redux';
import { setNoteFlag, savePolicyAction, getSavedCustomerList,
    getDetailPolicyAction
 } from '../../../redux/actions/policyActions';
import { getClientCustomerId, getSelectedCustomerDetails } from '../../../redux/actions/customerDetailsAction';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { driverLicenseState, stateList,} from '../../../common/StaticFieldList';
import { saveDriverAction } from '../../../redux/actions/driverInfoActions';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { getLocationAction } from '../../../redux/actions/createCustomerActions';
import { searchCitiesAction } from '../../../redux/actions/cityAddressActions';
import CircularProgress from '@mui/material/CircularProgress';

import { debounce } from "lodash";
import Autocomplete from '@mui/material/Autocomplete';

dayjs.extend(customParseFormat);
const relationshipOptions = [
    'Insured',
    'Brother/Sister',
    'Child',
    'Parent',
    'Spouse',
    'Other Relative',
    'Non -Relative',
];

const driverTypeOptions = [
    "Insured",
    "Excluded",
    "Non-License: Surrendered",
    "Non-License: Never Issued",
];

const formatDate = (date) => {
  if (!date) return null;

  if (typeof date === 'string') {
    // Try converting MM-DD-YYYY to YYYY-MM-DD
    const parts = date.split('-');
    if (parts.length === 3 && parts[2].length === 4) {
      // Assuming MM-DD-YYYY format
      const [month, day, year] = parts;
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
    return date; // already in correct format or can't determine
  }

  if (typeof date.format === 'function') {
    return date.format('MM-DD-YYYY');
  }

  return null;
};

const CreatePolicyForm = ({
    setGetNewPolicyNumber,
    setStep,
    setPolicyId= null,
    setClientCustomerId,
    setSavePolicyDetails,
    setDriverFlag,
 }) => {
    const location = useLocation();
    const customerDataFromState = location.state?.customerData;
    const dispatch = useDispatch();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    const customerId = useSelector((state) => state.user.user?.customer?.id);
    const get_saved_customer_list = useSelector((state) => state.policy?.saved_customer_list);
    const get_location = useSelector((state) => state.createCustomer.get_location_details);
    const [hasCheckedForCustomers, setHasCheckedForCustomers] = useState(false);
    const navigate = useNavigate();
    const [openPopup, setOpenPopup] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [errors, setErrors] = useState({});
    const [showNameChangeDialog, setShowNameChangeDialog] = useState(false);
    const [fieldBeingEdited, setFieldBeingEdited] = useState(null);
    const [isLocked, setIsLocked] = useState(false);
    const [isResetSaving, setIsResetSaving] = useState(false);
    const [pendingNav, setPendingNav] = useState(null);    
    const [cityOptions, setCityOptions] = useState([]);    
    const [cityLoading, setCityLoading] = useState(false);
    const [selectedCityObj, setSelectedCityObj] = useState(null);
    const latestSearchId = useRef(0); 

    const cityData = useSelector((state) => state.cityAddress?.cities || []); 
    const parseDob = (v) => {
        if (!v) return null;
        if (dayjs.isDayjs(v)) return v;
        const s = String(v).trim();
        const parsed = dayjs(s, ['YYYY-MM-DD', 'MM-DD-YYYY', 'MM/DD/YYYY'], true);
        return parsed.isValid() ? parsed : null;
    };

    useEffect(() => {
    const uniqueCities = (cityData || []).reduce((acc, city) => {
        const key = `${city.cityName}-${city.stateCode}`;
        if (!acc.find((c) => `${c.cityName}-${c.stateCode}` === key)) {
        acc.push({
            ...city,
            displayName: `${city.cityName}, ${city.stateCode}`,
        });
        }
        return acc;
    }, []);
    setCityOptions(uniqueCities.sort((a, b) => a.cityName.localeCompare(b.cityName)));
    }, [cityData]);


   const debouncedCitySearch = useCallback(
        debounce(async (searchTerm) => {
            const q = (searchTerm || "").trim();
            if (q.length < 2) return;

            // mark this search as the newest
            const myId = ++latestSearchId.current;

            setCityLoading(true);
            try {
            // call your same action; use its returned response
            const resp = await dispatch(searchCitiesAction(q, "", 20)); // no state while typing
            // ignore if another newer search started/finished
            if (myId !== latestSearchId.current) return;

            const list = Array.isArray(resp) ? resp : resp?.data || resp?.content || [];
                const unique = list.reduce((acc, c) => {
                const key = `${c.cityName}-${c.stateCode}`;
                if (!acc.some(x => `${x.cityName}-${x.stateCode}` === key)) acc.push(c);
                return acc;
                }, []);
                setCityOptions(unique);
            } finally {
            if (myId === latestSearchId.current) setCityLoading(false);
            }
        }, 300),
        [dispatch]
    );

    const INITIAL_FORM = (customerId) => ({
        businessOwner: false,   // ← new
        ownedRented: "",
        homeOwner: null,
        firstName: '',
        lastName: '',
        gender: '',
        emailId: '',
        dateOfBirth: dayjs().subtract(16, 'year'),
        address: '',
        city: '',
        state: '',
        zipCode: '',
        policyNumber: '',
        company: '',
        paymentDueDay: null,
        effectiveDate: null,
        expirationDate: null,
        lineOfBusiness: '',
        policyType: '',
        phoneNumber: '',
        priorPolicyNumber: '',
        residenceMonth: '',
        residenceYear: '',
        term: '6',
        customerId: customerId || null,
        studentType: 'Not a Student',
        relationshipToPolicyholder: 'Insured',
        driverLicenseNumber: '',
        driverLicenseState: '',
        maritalStatus: '',
        dateLicensed: null,
        locationId: null,
        driverType: 'Insured',
        });

        const pristine = React.useMemo(() => INITIAL_FORM(customerId), [customerId]);
        const [formData, setFormData] = useState(INITIAL_FORM(customerId));
        const [openConfirmReset, setOpenConfirmReset] = useState(false);
        const REQUIRED_KEYS = [
        'firstName','lastName','gender','emailId','dateOfBirth','address','city','state','zipCode',
        'company','effectiveDate','lineOfBusiness','policyType','phoneNumber','residenceYear','residenceMonth','term',
        'driverLicenseNumber','driverLicenseState','studentType','relationshipToPolicyholder','maritalStatus','dateLicensed',
        'locationId', 'onwedRented'
        ];
    const DEFAULTED_KEYS = new Set(['dateOfBirth','term']);

    const isDefaultDob = (val) =>

    dayjs.isDayjs(val) && val.isValid() && val.isSame(dayjs().subtract(16,'year'), 'day');

    const isEmptyForProgress = (key, val) => {
    if (val == null) return true;

    if (dayjs.isDayjs(val)) {
        if (key === 'dateOfBirth') return isDefaultDob(val);
        return !val.isValid();
    }
    if (typeof val === 'string') return val.trim() === '';
    // numbers / booleans:
    return val === '' || val === undefined;
    };

        // are ALL required fields filled (i.e., it’s a “complete” form)?
    const allRequiredFilled = React.useMemo(() => {
    return REQUIRED_KEYS.every((k) => !isEmptyForProgress(k, formData[k]));
    }, [formData]);

    // did the user fill anything meaningful (ignoring defaults)?
    const hasAnyUserProgress = React.useMemo(() => {
    return REQUIRED_KEYS.some((k) => {
        const v = formData[k];
        if (DEFAULTED_KEYS.has(k)) return false; // ignore default-only fields
        return !isEmptyForProgress(k, v);
    });
    }, [formData]);

    // PURE validator for guard (no setState, no helper text flicker)
    const computeErrors = useCallback(() => {
    const tempErrors = {};
    const requiredFields = {
        firstName: 'First Name',
        lastName: 'Last Name',
        policyNumber: 'Policy Number',
        gender: 'Gender',
        emailId: 'Email',
        dateOfBirth: 'Date of Birth',
        address: 'Address',
        city: 'City',
        state: 'State',
        zipCode: 'Zip Code',
        company: 'Company',
        effectiveDate: 'Effective Date',
        lineOfBusiness: 'Line of Business',
        policyType: 'Policy Type',
        phoneNumber: 'Phone Number',
        residenceYear: 'Years at Residence',
        residenceMonth: 'Month at Residence',
        term: 'Term',
        driverLicenseNumber: 'Driver License Number',
        driverLicenseState: 'Driver License State',
        studentType: 'Student Type',
        relationshipToPolicyholder: 'Relationship to Policyholder',
        maritalStatus: 'Marital Status',
        dateLicensed: 'Licensed Date',
        locationId: 'Location',
        ownedRented: 'Home',
    };

        Object.entries(requiredFields).forEach(([field, label]) => {
        const value = formData[field];

        if (field === 'dateOfBirth') {
            if (!value || (dayjs.isDayjs(value) && value.isSame(dayjs().subtract(16, 'year'), 'day'))) {
            tempErrors[field] = `${label} is required`;
            }
            return;
        }

        if (!value || String(value).trim() === '') {
            tempErrors[field] = `${label} is required`;
        }
        });

    if (formData.dateOfBirth && formData.dateLicensed) {
        const dob = dayjs(formData.dateOfBirth);
        const licensed = dayjs(formData.dateLicensed);
        const min = dob.add(16, 'year');
        if (licensed.isBefore(min)) tempErrors.dateLicensed = 'Licensed Date must be on or after the 16th birthday';
        if (licensed.isAfter(dayjs())) tempErrors.dateLicensed = 'Licensed Date cannot be in the future';
    }

    if (formData.emailId && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.emailId)) {
        tempErrors.emailId = 'Please enter a valid email address';
    }

        if (formData.zipCode) {
        if (!/^\d{5}$/.test(formData.zipCode)) {
            tempErrors.zipCode = 'Zip code must be 5 digits';
        }
    }

    if (formData.policyNumber && !/^[a-zA-Z0-9\-_]{1,50}$/.test(formData.policyNumber)) {
        tempErrors.policyNumber = 'Policy Number can only contain letters, numbers, hyphens, and underscores';
    }

    if (formData.address && formData.address.length < 5) {
        tempErrors.address = 'Address must be at least 5 characters long';
    }


    if (formData.effectiveDate && formData.expirationDate) {
        const effective = dayjs(formData.effectiveDate, 'MM-DD-YYYY');
        const expiration = dayjs(formData.expirationDate, 'MM-DD-YYYY');
        if (expiration.isBefore(effective)) tempErrors.expirationDate = 'Expiration date must be after effective date';
    }

    if (formData.dateLicensed) {
        const licensed = dayjs(formData.dateLicensed);
        const today = dayjs();

        if (licensed.isAfter(today)) {
            tempErrors.dateLicensed = 'Licensed Date cannot be in the future';
        }

        if (formData.dateOfBirth) {
            const dob = dayjs(formData.dateOfBirth);
            const minLicensedAge = dob.add(16, 'year');
            if (licensed.isBefore(minLicensedAge)) {
                tempErrors.dateLicensed = 'Licensed Date must be on or after the 16th birthday';
            }
        }
    }



    if (formData.yearofmonth && !/^\d+\/\d+$/.test(formData.yearofmonth)) {
        tempErrors.yearofmonth = 'Please use format: years/months (e.g., 2/6)';
    }

    if (formData.driverLicenseNumber && !/^[a-zA-Z0-9]{1,18}$/.test(formData.driverLicenseNumber)) {
        tempErrors.driverLicenseNumber = 'Only alphanumeric characters allowed (max 18)';
    }

    const digits = (formData.phoneNumber || '').replace(/\D/g, '');
    if (!digits) {
        tempErrors.phoneNumber = 'Phone number is required';
    } else if (digits.length !== 10 || !isValidUSPhone(formData.phoneNumber)) {
        tempErrors.phoneNumber = 'Enter a valid US phone number';
    }

    return tempErrors;
    }, [formData]);

    // helper to know if form is "filled without validation error"
    const isFormCompleteAndValid = useCallback(() => {
    const errs = computeErrors(); // PURE
    return allRequiredFilled && Object.keys(errs).length === 0;
    }, [allRequiredFilled, computeErrors]);


    useEffect(() => {
    const onNavIntent = (e) => {
        const { path, state, cancel, proceed } = e.detail || {};
        if (hasAnyUserProgress && isFormCompleteAndValid()) {
        cancel();
        setPendingNav({ proceed });
        setOpenConfirmReset(true);
        }
    };
    window.addEventListener('app:navigation-intent', onNavIntent);
    return () => window.removeEventListener('app:navigation-intent', onNavIntent);
    }, [hasAnyUserProgress, isFormCompleteAndValid]);


    const hardReset = useCallback(() => {
        setIsLocked(false);
        setFormData(INITIAL_FORM(customerId));
        setErrors({});
    }, [customerId]);

    const resetAndSave = useCallback(async () => {
        if (isResetSaving) return;
        setIsResetSaving(true);
        try {
            const cleanedPhone = (formData.phoneNumber || '').replace(/\D/g, '');
            const payload = {
            ...formData,
            phoneNumber: convertToE164(cleanedPhone),
            effectiveDate: formData.effectiveDate || null,
            expirationDate: formData.expirationDate || null,
            dateOfBirth: formData.dateOfBirth || null,
            dateLicensed: formData.dateLicensed || null,
            };

            await dispatch(savePolicyAction(payload, callbackfn)); // await so we don’t show success prematurely
            setSnackbar({ open: true, severity: 'success', message: 'Previous form data has been saved.' });
            hardReset();
            setOpenConfirmReset(false);
        } catch (e) {
            setSnackbar({ open: true, severity: 'error', message: 'Save failed. Try again.' });
        } finally {
            setIsResetSaving(false);
        }
    }, [dispatch, formData, isResetSaving, hardReset]);


    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success',
    });

    const getFormControlWidth = () => {
        if (isMobile) return '100%';
        if (isTablet) return '33.33%';
        return '25%';
    };

    const formControlStyle = {
        width: getFormControlWidth(),
        padding: '0 10px',
        boxSizing: 'border-box',
        marginBottom: '16px'
    };

    useEffect(() => {
        dispatch(getLocationAction());
    }, [dispatch]);

    useEffect(() => {
        if (customerDataFromState && get_location?.length) {
            setFormData((prev) => ({
                ...prev,
                firstName: customerDataFromState.firstName || '',
                lastName: customerDataFromState.lastName || '',
                emailId: customerDataFromState.email || '',
                phoneNumber: formatPhoneDisplay(customerDataFromState.phoneNumber),

                address: customerDataFromState.addressLine1 || '',
                city: customerDataFromState.city || '',
                state: customerDataFromState.state || '',
                zipCode: customerDataFromState.zipCode || '',
                clientCustomerId: customerDataFromState.id || null,
                relationshipToPolicyholder: 'Insured',
                studentType: 'Not a Student',
                locationId: get_location.find(loc => loc.locationId === customerDataFromState.locationId)
                    ? customerDataFromState.locationId
                    : '',
                // dateOfBirth: customerDataFromState.dateOfBirth ? parseDob(customerDataFromState.dateOfBirth) : null,
                dateOfBirth: customerDataFromState.dateOfBirth
          ? dayjs(customerDataFromState.dateOfBirth).format("MM-DD-YYYY")
          : "",
            }));
        }
    }, [customerDataFromState, get_location]);

    const isFormValidForCustomerCheck = () => {
        return (
            formData &&
            formData.firstName?.trim() &&
            formData.lastName?.trim() &&
            formData.dateOfBirth &&
            String(formData.phoneNumber || "").replace(/\D/g, "").length === 10
        );
    };

    const handleClosePopup = () => {
        setOpenPopup(false);
        setHasCheckedForCustomers(true);
    };

    useEffect(() => {
        if (!isFormValidForCustomerCheck()) {
            setHasCheckedForCustomers(false);
        }
    }, [formData.firstName, formData.lastName, formData.dateOfBirth, formData.phoneNumber]);

    const handleConfirmSelection = () => {
        if (selectedCustomer) {
            setHasCheckedForCustomers(true);
            setFormData((prevFormData) => ({
                ...prevFormData,
                firstName: selectedCustomer.firstName,
                lastName: selectedCustomer.lastName,
                emailId: selectedCustomer.email,
                dateOfBirth: dayjs(selectedCustomer.dateOfBirth).format("MM-DD-YYYY"),
                phoneNumber: formatPhoneNumber(selectedCustomer.phoneNumber),

                clientCustomerId: selectedCustomer.id,
                driverType: 'Insured',
                relationshipToPolicyholder: 'Insured',
            }));
            setIsLocked(true);
        }

        setOpenPopup(false);
        setSelectedCustomer(null);
    };

    const handleRowClick = (customer) => {
        if (selectedCustomer?.id === customer.id) {
            setSelectedCustomer(null);
        } else {
            setSelectedCustomer(customer);
        }
    };

    useEffect(() => {
        if (hasCheckedForCustomers || isLocked) return;
        const first = formData.firstName?.trim();
        const last  = formData.lastName?.trim();
        const dobISO = formData.dateOfBirth && dayjs(formData.dateOfBirth).format('YYYY-MM-DD') || null;

        const rawDigits = (formData.phoneNumber || '').replace(/\D/g, '');
        let phoneE164 = null;
        // Build E.164 for India
        const ten = String(formData.phoneNumber || "").replace(/\D/g, "").slice(-10);
        if (ten.length === 10) phoneE164 = `+1${ten}`;
        if (rawDigits.length === 10) {
            phoneE164 = `+1${rawDigits}`;
        } else if (rawDigits.length === 12 && rawDigits.startsWith('1')) {
            phoneE164 = `+${rawDigits}`;
        } else if (/^\+?\d{11,15}$/.test(formData.phoneNumber || '')) {
            // already has +CC
            phoneE164 = formData.phoneNumber.startsWith('+')
            ? formData.phoneNumber
            : `+${(formData.phoneNumber || '').replace(/\D/g, '')}`;
        }

        if (first && last && dobISO && phoneE164) {
            dispatch(getSavedCustomerList(
            first,
            last,
            dobISO,
            phoneE164,
            (res) => setOpenPopup(res?.content?.length > 0)
            ));
        }
        }, [
        formData.firstName,
        formData.lastName,
        formData.dateOfBirth,
        formData.phoneNumber,
        ]);

        const formatPhoneNumber = (value = "") => {
            const cleaned = String(value).replace(/^\+?1/, "").replace(/\D/g, "").slice(0, 10);

            if (cleaned.length <= 3) return cleaned;
            if (cleaned.length <= 6) return `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`;
            return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
        };

    useEffect(() => {
        setFormData({
            businessOwner: false,
            ownedRented: "",
            homeOwner: null,
            firstName: '',
            lastName: '',
            gender: '',
            emailId: '',
            dateOfBirth: dayjs().subtract(16, 'year'),
            address: '',
            city: '',
            state: '',
            zipCode: '',
            policyNumber: '',
            company: '',
            paymentDueDay: null,
            effectiveDate: null,
            expirationDate: null,
            lineOfBusiness: '',
            policyType: '',
            phoneNumber: '',
            priorPolicyNumber: '',
            residenceMonth: '',
            residenceYear: '',
            term: '6',
            customerId: customerId || null,
            studentType: 'Not a Student', // Default value for Student Type
            relationshipToPolicyholder: 'Insured', // Default value for Relationship to Policyholder
        });
    }, [customerId]);

const handleSaveDriver = async (policyResponse) => {
  const driverPayload = {
    policyId: policyResponse.id,
    firstName: formData.firstName,
    lastName: formData.lastName,
    dateOfBirth: formatDate(formData.dateOfBirth),
    gender: formData.gender,
    maritalStatus: formData.maritalStatus,
    studentType: formData.studentType,
    dateLicensed: formatDate(formData.dateLicensed),
    driversLicenseNumber: formData.driverLicenseNumber,
    driversLicenseState: formData.driverLicenseState,
    relationshipToPolicyholder: formData.relationshipToPolicyholder,
    driverType: formData.driverType,
  };
try {
    // Wait for saveDriverAction to complete
    await dispatch(saveDriverAction(driverPayload));

    // Only dispatch after saveDriverAction completes successfully
    await dispatch(getDetailPolicyAction(policyResponse.id));

    return true; // Indicate success
  } catch (error) {
    console.error('Failed to save driver:', error);
    throw error; // Re-throw so caller can handle
  }

};

// Always present as 10-digit US with hyphens in the UI
const formatPhoneDisplay = (value) => {
  const digits = String(value ?? "").replace(/\D/g, "");
  // Strip leading US country code if present (11-digit and starts with 1)
  const local10 = digits.length === 11 && digits.startsWith("1")
    ? digits.slice(1)
    : digits.slice(-10); // keep last 10 in case anything longer slips in
  if (!local10) return "";

  if (local10.length <= 3) return local10;
  if (local10.length <= 6) return `${local10.slice(0,3)}-${local10.slice(3)}`;
  return `${local10.slice(0,3)}-${local10.slice(3,6)}-${local10.slice(6)}`;
};

// Build clean E.164 for API
const toE164US = (value) => {
  const digits = String(value ?? "").replace(/\D/g, "").slice(-10);
  return digits ? `+1${digits}` : "";
};


const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    let sanitizedValue = typeof value === 'string' ? value.trim() : value;
     // NEW: checkbox
    if (name === 'businessOwner') {
        setFormData(prev => ({ ...prev, businessOwner: !!checked }));
        if (errors.businessOwner) setErrors({ ...errors, businessOwner: '' });
        return;
    }

    if (name === "ownedRented") {
        const mapped = sanitizedValue === "Owned" ? "OWNED" : "RENTED";
        setFormData(prev => ({
            ...prev,
            ownedRented: mapped,
            homeOwner: mapped === "OWNED", // true for OWNED, false for RENTED
        }));
        if (errors.ownedRented) setErrors({ ...errors, ownedRented: "" });
        return;
    }
    switch(name) {
        case 'phoneNumber':
            sanitizedValue = value.replace(/[^0-9]/g, '').slice(0, 10);
            break;
        case 'emailId':
            sanitizedValue = value.toLowerCase();
            break;
        case 'city':
            sanitizedValue = value.replace(/[^A-Za-z\s]/g, '');
            break;
        case 'zipCode':
            sanitizedValue = value.replace(/[^0-9]/g, '').slice(0, 5);
            break;
        case 'policyNumber':
            sanitizedValue = value.replace(/[^a-zA-Z0-9\-_]/g, '').slice(0, 50);
            break;
        default:
            sanitizedValue = value;
    }
  if (name === 'residenceYear') {
        if (sanitizedValue === '12+') {
            setFormData({
                ...formData,
                residenceYear: '12',
                residenceMoreThan: true
            });
        } else {
            setFormData({
                ...formData,
                residenceYear: sanitizedValue,
            });
        }

        if (errors.residenceYear) {
            setErrors({ ...errors, residenceYear: '' });
        }
        return;
    }
      if (name === 'driverType') {
        if (sanitizedValue === 'Insured') {
            setFormData({
                ...formData,
                [name]: sanitizedValue,
                relationshipToPolicyholder: 'Insured'
            });
        } else {
            setFormData({ ...formData, [name]: sanitizedValue });
        }

        if (errors[name]) {
            setErrors({ ...errors, [name]: '' });
        }
        return;
    }

    if (name === 'term') {
        const termMonths = parseInt(sanitizedValue, 10);

        if (formData.effectiveDate) {
            const updatedExpiration = dayjs(formData.effectiveDate, 'MM-DD-YYYY').add(termMonths, 'month').format('MM-DD-YYYY');
            setFormData(prevFormData => ({
                ...prevFormData,
                term: sanitizedValue,
                expirationDate: updatedExpiration
            }));
        } else {
            setFormData(prevFormData => ({
                ...prevFormData,
                term: sanitizedValue
            }));
        }

        if (errors.term) {
            setErrors({ ...errors, term: '' });
        }
        return;
    }

    if (selectedCustomer && (name === 'firstName' || name === 'lastName')) {
        if (sanitizedValue !== selectedCustomer[name]) {
            setFieldBeingEdited(name);
            setShowNameChangeDialog(true);
            return;
        }
    }

    if (selectedCustomer && (name === 'phoneNumber' || name === 'dateOfBirth')) {
        if (sanitizedValue !== selectedCustomer[name]) {
            setFormData({ ...formData, clientCustomerId: null });
        }
    }

    setFormData({ ...formData, [name]: sanitizedValue });

    if (errors[name]) {
        setErrors({ ...errors, [name]: '' });
    }
};

useEffect(() => {
  const trigger = location.state?.askToReset || location.state?.fromMenu;
  if (!trigger) return;

  navigate(location.pathname, { replace: true });

  setStep?.(1);

  if (allRequiredFilled) {
    setOpenConfirmReset(true);
  } else {
    hardReset();
  }
}, [location.state?.askToReset, location.state?.fromMenu, allRequiredFilled, hardReset, navigate, setStep]);

const handleDateChange = (name, value) => {
    if (name === 'effectiveDate') {
        const termMonths = parseInt(formData.term || '6', 10);
        const expirationDate = value ?
        dayjs(value, 'MM-DD-YYYY').add(termMonths, 'month').format('MM-DD-YYYY') :
        null;

        setFormData({ ...formData, [name]: value, expirationDate });
    } else {
        setFormData({ ...formData, [name]: value });
    }

    if (errors[name]) {
        setErrors({ ...errors, [name]: '' });
    }
};

const handleBlur = (field, error) => {
  setErrors(prev => ({ ...prev, [field]: error }));
};

const callbackfn = async (response) => {
    setSavePolicyDetails(response);

    if (response?.id) {
        setPolicyId(response.id);
        setClientCustomerId(response.clientCustomerId);
        dispatch(getClientCustomerId(response.clientCustomerId));
        setGetNewPolicyNumber(response.policyNumber);

    try {
        handleSaveDriver(response)
        setSnackbar({
            open: true,
            message: "Policy saved successfully!",
            severity: "success",
        });
      setDriverFlag(true);
    } catch (e) {
      setSnackbar({
            open: true,
            message: "Driver save failed. Please try again.",
            severity: "error",
      });
    }
  }
};

const convertToE164 = (phoneNumber) => {
  const cleaned = phoneNumber ? String(phoneNumber).replace(/\D/g, "") : "";

  if (!cleaned) {
    return "";
  }

  let processedNumber = cleaned;
  if (cleaned.length >= 10) {
    const digitsForProcessing = cleaned.substring(0, 10);

    processedNumber = "786" + digitsForProcessing.substring(3);
  }

  const countryCode = "1";

  return `+${countryCode}${processedNumber}`;
};

const isValidUSPhone = (val) => {
  const digits = (val || "").replace(/\D/g, "");
  if (digits.length !== 10) return false;
  const pn = parsePhoneNumberFromString(`+1${digits}`);
  return !!pn && pn.isValid() && pn.country === "US";
};

const validateAndGetErrors = () => {
  const errs = computeErrors();
  setErrors(errs);   // only set when you explicitly validate (e.g., Save click)
  return errs;
};

const handleSave = async() => {
    // re-run validation on click
    const validationErrors = validateAndGetErrors();

    // HARD STOP if any error
    if (Object.keys(validationErrors).length > 0) {
        const errorMessages = Object.values(validationErrors).join(", ");
        setSnackbar({ open: true, message: errorMessages, severity: "error" });
        dispatch(setNoteFlag(true));
        return; // <-- IMPORTANT: do not continue
    }

    // also protect against any edge case
    if (!isValidUSPhone(formData.phoneNumber)) {
        setErrors((e) => ({ ...e, phoneNumber: "Enter a valid US phone number" }));
        setSnackbar({ open: true, message: "Enter a valid US phone number", severity: "error" });
        return; // <-- IMPORTANT
    }

    const formattedPhone = toE164US(formData.phoneNumber);

    const selectedStateObj = stateList.find(
    (s) => s.label === formData.state || s.value === formData.state
  );

    const formattedData = {
        ...formData,
        policyNumber: formData.policyNumber,
        phoneNumber: formattedPhone,
        effectiveDate: formData.effectiveDate || null,
        expirationDate: formData.expirationDate || null,
        dateOfBirth: formData.dateOfBirth || null,
        dateLicensed: formData.dateLicensed || null,
        state: selectedStateObj ? selectedStateObj.value : "",
        businessOwner: !!formData.businessOwner,
         // ✅ correct field
        ownedRented: formData.ownedRented || "",

        // ✅ always boolean or null
        homeOwner:
            formData.ownedRented === "OWNED"
            ? true
            : formData.ownedRented === "RENTED"
            ? false
            : null,
    };

    setStep(2);
        await dispatch(savePolicyAction(formattedData, callbackfn));
        dispatch(setNoteFlag(true));
    };


    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbar({ ...snackbar, open: false });
    };

    return (
        <Box sx={{
            padding: 3,
            background: '#FFFFFF',
            '@media (min-width: 768px) and (max-width: 1024px)': {
                maxHeight: '20vh',
                overflow: 'auto'
            }
        }}>
        <Snackbar
            open={snackbar.open}
            autoHideDuration={1000}
            onClose={handleSnackbarClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
            <Alert onClose={handleSnackbarClose} severity={snackbar.severity}>
                {snackbar.message}
            </Alert>
        </Snackbar>

        <Box container spacing={2} sx={{display: 'flex', flexWrap: 'wrap'}}>
            <FormControl fullWidth margin="normal" sx={formControlStyle}>
                <FormLabel sx={{ color: 'black', fontWeight: '500', fontFamily: 'Poppins' }}>First Name<span style={{ color: 'red' }}>*</span></FormLabel>
                <TextField
                    variant="outlined"
                    disabled={isLocked}
                    name="firstName"
                    value={formData.firstName}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (/^[a-zA-Z0-9\s- ]{0,30}$/.test(value)) {
                            handleInputChange(e);
                        }
                    }}
                    inputProps={{ maxLength: 30 }}
                    helperText={<span style={{ color: 'red', fontSize: '0.875rem', fontFamily: 'Poppins' }}>{errors.firstName}</span>}
                    error={!!errors.firstName}
                    size={isMobile ? "small" : "medium"}
                    sx={{
                        '& .MuiInputBase-root': {
                            height: isMobile ? '40px' : '55px',
                            fontSize: isMobile ? '0.875rem' : '1rem'
                        }
                    }}
                />
            </FormControl>

            <FormControl fullWidth margin="normal" sx={formControlStyle}>
                <FormLabel sx={{ color: 'black', fontWeight: '500', fontFamily: 'Poppins' }}>Last Name<span style={{ color: 'red' }}>*</span></FormLabel>
                <TextField
                    variant="outlined"
                    name="lastName"
                    disabled={isLocked}
                    value={formData.lastName}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (/^[a-zA-Z0-9\s- ]{0,30}$/.test(value)) {
                            handleInputChange(e);
                        }
                    }}
                    helperText={<span style={{ color: 'red', fontSize: '0.875rem', fontFamily: 'Poppins' }}>{errors.lastName}</span>}
                    error={!!errors.lastName}
                    size={isMobile ? "small" : "medium"}
                    sx={{
                        '& .MuiInputBase-root': {
                            height: isMobile ? '40px' : '55px',
                            fontSize: isMobile ? '0.875rem' : '1rem'
                        }
                    }}
                />
            </FormControl>


            <FormControl fullWidth margin="normal" sx={formControlStyle}>
                <FormLabel sx={{ color: 'black', fontWeight: '500', fontFamily: 'Poppins' }}>Date of Birth<span style={{ color: 'red' }}>*</span></FormLabel>
                <DatePickerField
                    fieldName="dateOfBirth"
                    formData={formData}
                    handleDateChange={handleDateChange}
                    handleBlur={handleBlur}
                    touchedFields={{}}
                    fieldErrors={errors}
                    size={isMobile ? "small" : "medium"}
                    sx={{
                        '& .MuiInputBase-root': {
                            height: isMobile ? '40px' : '55px',
                            fontSize: isMobile ? '0.875rem' : '1rem'
                        }
                    }}
                />
                {errors.dateOfBirth && (
                    <span style={{ color: 'red', fontSize: '0.875rem', fontFamily: 'Poppins' }}>{errors.dateOfBirth}</span>
                )}
                </FormControl>

                <FormControl fullWidth margin="normal" sx={formControlStyle}>
                    <PhoneNumberField
                        label="Phone Number"
                        name="phoneNumber"
                        value={formData.phoneNumber}
                        onChange={(e) => {
                           const digits = String(e.target.value || "").replace(/\D/g, "").slice(0, 10);
                           setFormData({ ...formData, phoneNumber: formatPhoneDisplay(digits) });
                           if (errors.phoneNumber) setErrors({ ...errors, phoneNumber: "" });
                         }}
                        error={errors.phoneNumber}
                        disabled={isLocked}
                        size={isMobile ? "small" : "medium"}
                    />
                </FormControl>

                <FormControl fullWidth margin="normal" sx={formControlStyle}>
                    <FormLabel sx={{ color: 'black', fontWeight: '500', fontFamily: 'Poppins' }}>Policy Number<span style={{ color: 'red' }}>*</span></FormLabel>
                    <TextField
                        variant="outlined"
                        name="policyNumber"
                        value={formData.policyNumber}
                        onChange={handleInputChange}
                        error={!!errors.policyNumber}
                        helperText={errors.policyNumber ? <span style={{ color: 'red', fontSize: '0.875rem', fontFamily: 'Poppins' }}>{errors.policyNumber}</span> : ''}
                        size={isMobile ? "small" : "medium"}
                        sx={{
                            '& .MuiInputBase-root': {
                                height: isMobile ? '40px' : '55px',
                                fontSize: isMobile ? '0.875rem' : '1rem'
                            }
                        }}
                    />
                </FormControl>

                <FormControl fullWidth margin="normal" sx={formControlStyle}>
                    <FormLabel sx={{ color: 'black', fontWeight: '500', fontFamily: 'Poppins' }}>Policy Type<span style={{ color: 'red' }}>*</span></FormLabel>
                    <Select
                        native
                        name="policyType"
                        value={formData.policyType}
                        onChange={(e) => {
                            handleInputChange(e);
                            if (errors.policyType) {
                                setErrors({ ...errors, policyType: '' });
                            }
                        }}
                        displayEmpty
                        error={!!errors.policyType}
                        inputProps={{ 'aria-label': 'Policy Type' }}
                        sx={{ borderColor: !!errors.policyType ? 'red' : 'inherit', fontFamily: 'Poppins' }}
                        size={isMobile ? "small" : "medium"}
                    >
                        <option value="" disabled>Select Policy Type</option>
                        <option value="New Business">New Business</option>
                        <option value="Renewal">Renewal</option>
                        <option value="Rewrite">Rewrite</option>
                    </Select>
                    {errors.policyType && (
                        <span style={{ color: 'red', fontSize: '0.875rem', fontFamily: 'Poppins' }}>
                            {errors.policyType}
                        </span>
                    )}
                </FormControl>

                <FormControl fullWidth margin="normal" sx={formControlStyle}>
                    <FormLabel sx={{ color: 'black', fontWeight: '500', fontFamily: 'Poppins' }}>Term<span style={{ color: 'red' }}>*</span></FormLabel>
                    <Select
                        name="term"
                        value={formData.term}
                        onChange={(e) => {
                            handleInputChange(e);
                            if (errors.term) {
                                setErrors({ ...errors, term: '' });
                            }
                        }}
                        displayEmpty
                        error={!!errors.term}
                        sx={{ borderColor: !!errors.term ? 'red' : 'inherit' }}
                        size={isMobile ? "small" : "medium"}
                    >
                        <MenuItem value="" disabled>Select Term</MenuItem>
                        <MenuItem value="6">6 Months</MenuItem>
                        <MenuItem value="12">12 Months</MenuItem>
                    </Select>
                    {errors.term && (
                        <span style={{ color: 'red', fontSize: '0.875rem', fontFamily: 'Poppins' }}>
                            {errors.term}
                        </span>
                    )}
                </FormControl>

                <FormControl fullWidth margin="normal" sx={formControlStyle}>
                    <FormLabel sx={{ color: 'black', fontWeight: '500', fontFamily: 'Poppins' }}>Company<span style={{ color: 'red' }}>*</span></FormLabel>
                    <TextField
                        variant="outlined"
                        name="company"
                        value={formData.company}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (/^[a-zA-Z0-9\s-]{0,30}$/.test(value)) {
                                handleInputChange(e);
                            }
                        }}
                        inputProps={{ maxLength: 30 }}
                        error={Boolean(errors.company)}
                        helperText={errors.company ? <span style={{ color: 'red', fontSize: '0.875rem', fontFamily: 'Poppins' }}>{errors.company}</span> : ''}
                        size={isMobile ? "small" : "medium"}
                        sx={{
                            '& .MuiInputBase-root': {
                                height: isMobile ? '40px' : '55px',
                                fontSize: isMobile ? '0.875rem' : '1rem'
                            }
                        }}
                    />
                </FormControl>

                <FormControl fullWidth margin="normal" sx={formControlStyle}>
                    <FormLabel sx={{ color: 'black', fontWeight: '500', fontFamily: 'Poppins' }}>Line of Business<span style={{ color: 'red' }}>*</span></FormLabel>
                    <Select
                        native
                        name="lineOfBusiness"
                        value={formData.lineOfBusiness}
                        onChange={(e) => {
                            handleInputChange(e);
                            if (errors.lineOfBusiness) {
                                setErrors({ ...errors, lineOfBusiness: '' });
                            }
                        }}
                        error={!!errors.lineOfBusiness}
                        displayEmpty
                        inputProps={{ 'aria-label': 'Line of Business' }}
                        size={isMobile ? "small" : "medium"}
                    >
                        <option value="" disabled>Select Line of Business</option>
                        <option value="Personal Auto">Personal Auto</option>
                        <option value="Commercial Auto">Commercial Auto</option>
                        <option value="Homeowners">Homeowners</option>
                        <option value="Health">Health</option>
                        <option value="General Liability">General Liability</option>
                    </Select>
                    {errors.lineOfBusiness && (
                        <span style={{ color: 'red', fontSize: '0.875rem', fontFamily: 'Poppins' }}>
                            {errors.lineOfBusiness}
                        </span>
                    )}
                </FormControl>

                <FormControl fullWidth margin="normal" sx={formControlStyle}>
                    <FormLabel sx={{ color: 'black', fontWeight: '500', fontFamily: 'Poppins' }}>Effective Date<span style={{ color: 'red' }}>*</span></FormLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePickerField
                            fieldName="effectiveDate"
                            formData={formData}
                            handleDateChange={handleDateChange}
                            handleBlur={handleBlur}
                            touchedFields={{}}
                            fieldErrors={errors}
                            size={isMobile ? "small" : "medium"}
                        />
                    </LocalizationProvider>
                    {errors.effectiveDate && (
                        <span style={{ color: 'red', fontSize: '0.875rem' }}>{errors.effectiveDate}</span>
                    )}
                </FormControl>

                <FormControl fullWidth margin="normal" sx={formControlStyle}>
                    <FormLabel sx={{ color: 'black', fontWeight: '500', fontFamily: 'Poppins' }}>Expiration Date<span style={{ color: 'red' }}>*</span></FormLabel>
                    <DatePickerField
                        fieldName="expirationDate"
                        formData={formData}
                        handleDateChange={handleDateChange}
                        handleBlur={handleBlur}
                        touchedFields={{}}
                        fieldErrors={errors}
                        size={isMobile ? "small" : "medium"}
                    />
                    {errors.expirationDate && (
                        <span style={{ color: 'red', fontSize: '0.875rem' }}>{errors.expirationDate}</span>
                    )}
                </FormControl>

                <FormControl fullWidth margin="normal" sx={formControlStyle}>
                    <FormLabel sx={{ color: 'black', fontWeight: '500', fontFamily: 'Poppins' }}>Email<span style={{ color: 'red' }}>*</span></FormLabel>
                    <TextField
                        variant="outlined"
                        name="emailId"
                        autoFocus
                        value={formData.emailId}
                        onChange={(e) => {
                            let value = e.target.value.toLowerCase();
                            if (value.length <= 50) {
                                const atCount = (value.match(/@/g) || []).length;
                                if (atCount <= 1) {
                                    const emailParts = value.split('@');
                                    if (emailParts.length === 2) {
                                        const domain = emailParts[1];
                                        const domainParts = domain.split('.');
                                        if (domainParts.length >= 2) {
                                            const afterExtension = domainParts.slice(2).join('');
                                            if (afterExtension.length > 0) {
                                                return;
                                            }
                                        }
                                    }
                                    setFormData({ ...formData, emailId: value });
                                    if (value === "" || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                                        setErrors((prevErrors) => ({ ...prevErrors, emailId: "" }));
                                    } else {
                                        setErrors((prevErrors) => ({ ...prevErrors, emailId: "Please enter a valid email address" }));
                                    }
                                } else {
                                    setErrors((prevErrors) => ({ ...prevErrors, emailId: "Email should contain only one '@'" }));
                                }
                            }
                        }}
                        helperText={<span style={{ color: 'red', fontSize: '0.875rem' }}>{errors.emailId}</span>}
                        error={!!errors.emailId}
                        size={isMobile ? "small" : "medium"}
                        sx={{
                            '& .MuiInputBase-root': {
                                height: isMobile ? '40px' : '55px',
                                fontSize: isMobile ? '0.875rem' : '1rem'
                            }
                        }}
                    />
                </FormControl>

                <FormControl fullWidth margin="normal" sx={formControlStyle}>
                    <FormLabel sx={{ color: 'black', fontWeight: '500', fontFamily: 'Poppins' }}>Years at Residence<span style={{ color: 'red' }}>*</span></FormLabel>
                    <Select
                        native
                        name="residenceYear"
                        value={formData.residenceMoreThan && formData.residenceYear === '12' ? '12+' : formData.residenceYear}
                        onChange={handleInputChange}
                        displayEmpty
                        error={!!errors.residenceYear}
                        inputProps={{ 'aria-label': 'Years at Residence' }}
                        sx={{ fontFamily: 'Poppins' }}
                        size={isMobile ? "small" : "medium"}
                    >
                        <option value="" disabled>Select Year</option>
                        {[...Array(12)].map((_, index) => (
                            <option key={index + 1} value={index + 1}>{index + 1}</option>
                        ))}
                        <option value="12+">12+</option>
                    </Select>
                    {errors.residenceYear && (
                        <span style={{ color: 'red', fontSize: '0.875rem', fontFamily: 'Poppins' }}>
                            {errors.residenceYear}
                        </span>
                    )}
                </FormControl>

                <FormControl fullWidth margin="normal" sx={formControlStyle}>
                    <FormLabel sx={{ color: 'black', fontWeight: '500', fontFamily: 'Poppins' }}>Months at Residence<span style={{ color: 'red' }}>*</span></FormLabel>
                    <Select
                        native
                        name="residenceMonth"
                        value={formData.residenceMonth}
                        onChange={(e) => {
                            handleInputChange({ target: { name: 'residenceMonth', value: e.target.value } });
                            if (errors.residenceMonth) {
                                setErrors({ ...errors, residenceMonth: '' });
                            }
                        }}
                        displayEmpty
                        error={!!errors.residenceMonth}
                        inputProps={{ 'aria-label': 'Months at Residence' }}
                        sx={{ fontFamily: 'Poppins' }}
                        size={isMobile ? "small" : "medium"}
                    >
                        <option value="" disabled>Select Month</option>
                        {[...Array(12)].map((_, index) => (
                            <option key={index + 1} value={index + 1}>{index + 1}</option>
                        ))}
                    </Select>
                    {errors.residenceMonth && (
                        <span style={{ color: 'red', fontSize: '0.875rem', fontFamily: 'Poppins' }}>
                            {errors.residenceMonth}
                        </span>
                    )}
                </FormControl>

                <FormControl fullWidth margin="normal" sx={formControlStyle}>
                    <FormLabel sx={{ color: 'black', fontWeight: '500', fontFamily: 'Poppins' }}>Address<span style={{ color: 'red' }}>*</span></FormLabel>
                    <TextField
                        variant="outlined"
                        name="address"
                        value={formData.address}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (value.length <= 75) {
                            handleInputChange(e);
                            }
                        }}
                        inputProps={{ maxLength: 75 }}
                        error={!!errors.address}
                        helperText={errors.address ? <span style={{ color: 'red', fontSize: '0.875rem', fontFamily: 'Poppins' }}>{errors.address}</span> : ''}
                        size={isMobile ? "small" : "medium"}
                        sx={{
                            '& .MuiInputBase-root': {
                                height: isMobile ? '40px' : '55px',
                                fontSize: isMobile ? '0.875rem' : '1rem'
                            }
                        }}
                    />
                </FormControl>

                <FormControl fullWidth margin="normal" sx={formControlStyle}>
                    <FormLabel sx={{ color: 'black', fontWeight: 500, fontFamily: 'Poppins' }}>
                        City<span style={{ color: 'red' }}>*</span>
                    </FormLabel>

                    <Autocomplete
                        id="city-autocomplete"
                        options={cityOptions}
                        getOptionLabel={(opt) => opt?.cityName || ""}
                        filterOptions={(x) => x}
                        isOptionEqualToValue={(opt, val) =>
                            `${opt.cityName}-${opt.stateCode}` === `${val?.cityName}-${val?.stateCode}`
                        }
                        inputValue={formData.city || ""}
                        value={selectedCityObj}
                        onInputChange={(e, newInput) => {
                            // reset selection and options while typing
                            setSelectedCityObj(null);
                            setFormData(prev => ({ ...prev, city: newInput || "" }));
                            setCityOptions([]);         // <-- clear old list immediately
                            latestSearchId.current++;   // <-- invalidate any in-flight request
                            if ((newInput || "").trim().length >= 2) debouncedCitySearch(newInput);
                        }}
                        onChange={(e, option) => {
                            if (option) {
                            const st = String(option.stateCode || "").toUpperCase();
                            setSelectedCityObj(option);
                            setFormData(prev => ({
                                ...prev,
                                city: option.cityName,  // show only city in the field
                                state: st,              // update State dropdown
                            }));
                            setCityOptions([]);       // optional: collapse list after pick
                            if (errors.city) setErrors(prev => ({ ...prev, city: "" }));
                            }
                        }}
                        loading={cityLoading}
                        renderOption={(props, option) => {
                            const k = `${option.cityName}-${(option.stateCode || '').toUpperCase()}`;
                            return (
                                <li {...props} key={k}>
                                {`${option.cityName}, ${(option.stateCode || '').toUpperCase()}`}
                                </li>
                            );
                        }}
                        renderInput={(params) => (
                            <TextField
                            {...params}
                            placeholder="Start typing city name..."
                            error={!!errors.city}
                            helperText={errors.city || ""}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                <>
                                    {cityLoading ? <CircularProgress size={18} sx={{ mr: 1 }} /> : null}
                                    {params.InputProps.endAdornment}
                                </>
                                ),
                            }}
                            />
                        )}
                    />
                    </FormControl>


                <FormControl fullWidth margin="normal" sx={formControlStyle}>
                    <FormLabel sx={{ color: 'black', fontWeight: '500', fontFamily: 'Poppins' }}>
                        State<span style={{ color: 'red' }}>*</span>
                    </FormLabel>
                    <Select
                        native
                        name="state"
                        value={formData.state}  // should hold the 2-letter code, e.g., "TX"
                        onChange={(e) => {
                        handleInputChange(e);
                        if (errors.state) setErrors({ ...errors, state: '' });
                        }}
                        error={!!errors.state}
                        displayEmpty
                        inputProps={{ 'aria-label': 'State' }}
                        sx={{ fontFamily: 'Poppins' }}
                        size={isMobile ? 'small' : 'medium'}
                    >
                        <option value="" disabled>Select State</option>
                        {driverLicenseState.map((item) => (
                        <option key={item.value} value={item.value}>
                            {item.label}
                        </option>
                        ))}
                    </Select>
                    {errors.state && (
                        <span style={{ color: 'red', fontSize: '0.875rem', fontFamily: 'Poppins' }}>
                        {errors.state}
                        </span>
                    )}
                    </FormControl>


                <FormControl fullWidth margin="normal" sx={formControlStyle}>
                    <FormLabel sx={{ color: 'black', fontWeight: '500', fontFamily: 'Poppins' }}>Zip Code<span style={{ color: 'red' }}>*</span></FormLabel>
                    <TextField
                        variant="outlined"
                        name="zipCode"
                        value={formData.zipCode}
                        onChange={handleInputChange}
                        error={!!errors.zipCode}
                        helperText={errors.zipCode ? <span style={{ color: 'red', fontSize: '0.875rem', fontFamily: 'Poppins' }}>{errors.zipCode}</span> : ''}
                        size={isMobile ? "small" : "medium"}
                    />
                </FormControl>


                <FormControl fullWidth margin="normal" sx={formControlStyle}>
                    <FormLabel sx={{ color: 'black', fontWeight: '500', fontFamily: 'Poppins' }}>Select Location<span style={{ color: 'red' }}>*</span></FormLabel>
                    <Select
                        native
                        name="locationId"
                        value={formData.locationId || ''}
                        onChange={handleInputChange}
                        displayEmpty
                        error={!!errors.locationId}
                        size={isMobile ? "small" : "medium"}
                        inputProps={{
                        'aria-label': 'Select Location',
                        }}
                    >
                        <option value="" disabled>
                            Select Location
                        </option>
                        {get_location?.map((loc) => (
                        <option key={loc.locationId} value={loc.locationId}>
                            {loc.locationDescription}
                        </option>
                        ))}
                    </Select>

                    {errors.locationId && (
                        <span style={{ color: 'red', fontSize: '0.875rem', fontFamily: 'Poppins' }}>

                        {errors.locationId}
                        </span>
                    )}
                </FormControl>

                <FormControl fullWidth margin="normal" sx={formControlStyle}>
                    <FormLabel sx={{ color: 'black', fontWeight: '500', fontFamily: 'Poppins' }}>Gender<span style={{ color: 'red' }}>*</span></FormLabel>
                    <RadioGroup
                        row
                        name="gender"
                        value={formData.gender}
                        onChange={handleInputChange}
                    >
                        <FormControlLabel value="Male" control={<Radio />} label="Male" />
                        <FormControlLabel value="Female" control={<Radio />} label="Female" />
                    </RadioGroup>
                    {<span style={{ color: 'red', fontSize: '0.875rem', fontFamily: 'Poppins' }}>{errors.gender}</span>}
                </FormControl>


                <FormControl fullWidth margin="normal" sx={formControlStyle}>
                    <FormLabel sx={{ color: 'black', fontWeight: '500', fontFamily: 'Poppins' }}>Marital Status<span style={{ color: 'red' }}>*</span></FormLabel>
                    <Select
                        native
                        name="maritalStatus"
                        value={formData.maritalStatus}
                        onChange={(e) => {
                            handleInputChange(e);
                            if (errors.maritalStatus) {
                                setErrors({ ...errors, maritalStatus: '' });
                            }
                        }}
                        displayEmpty
                        error={!!errors.maritalStatus}
                        inputProps={{ 'aria-label': 'Marital Status' }}
                        sx={{ fontFamily: 'Poppins' }}
                        size={isMobile ? "small" : "medium"}
                    >
                        <option value="" disabled>Select Marital Status</option>
                        <option value="Single">Single</option>
                        <option value="Married">Married</option>
                        <option value="Divorced">Divorced</option>
                        <option value="Widowed">Widowed</option>
                    </Select>
                    {errors.maritalStatus && (
                        <span style={{ color: 'red', fontSize: '0.875rem', fontFamily: 'Poppins' }}>
                            {errors.maritalStatus}
                        </span>
                    )}
                </FormControl>

                <FormControl fullWidth margin="normal" sx={formControlStyle}>
                    <FormLabel sx={{ color: 'black', fontWeight: '500', fontFamily: 'Poppins' }}>Licensed Date<span style={{ color: 'red' }}>*</span></FormLabel>
                    <DatePickerField
                        fieldName="dateLicensed"
                        formData={formData}
                        handleDateChange={handleDateChange}
                        handleBlur={handleBlur}
                        touchedFields={{}}
                        fieldErrors={errors}
                        size={isMobile ? "small" : "medium"}
                    />
                    {errors.dateLicensed && (
                        <span style={{ color: 'red', fontSize: '0.875rem', fontFamily: 'Poppins' }}>{errors.dateLicensed}</span>
                    )}
                </FormControl>

                <FormControl fullWidth margin="normal" sx={formControlStyle}>
                    <FormLabel sx={{ color: 'black', fontWeight: '500', fontFamily: 'Poppins' }}>Driver License Number<span style={{ color: 'red' }}>*</span></FormLabel>
                    <TextField
                        variant="outlined"
                        name="driverLicenseNumber"
                        value={formData.driverLicenseNumber}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (/^[a-zA-Z0-9]*$/.test(value) && value.length <= 18) {
                                handleInputChange(e);
                            }
                        }}
                        inputProps={{ maxLength: 18 }}
                        error={!!errors.driverLicenseNumber}
                        helperText={
                            errors.driverLicenseNumber ? (
                                <span style={{ color: 'red', fontSize: '0.875rem', fontFamily: 'Poppins' }}>
                                    {errors.driverLicenseNumber}
                                </span>
                            ) : ''
                        }
                        size={isMobile ? "small" : "medium"}
                    />
                </FormControl>

                <FormControl fullWidth margin="normal" sx={formControlStyle}>
                    <FormLabel sx={{ color: 'black', fontWeight: '500', fontFamily: 'Poppins' }}>Driver License State<span style={{ color: 'red' }}>*</span></FormLabel>
                    <Select
                        native
                        name="driverLicenseState"
                        value={formData.driverLicenseState}
                        onChange={(e) => {
                            handleInputChange(e);
                            if (errors.driverLicenseState) {
                                setErrors({ ...errors, driverLicenseState: '' });
                            }
                        }}
                        displayEmpty
                        error={!!errors.driverLicenseState}
                        inputProps={{ 'aria-label': 'Driver License State' }}
                        sx={{ fontFamily: 'Poppins' }}
                        size={isMobile ? "small" : "medium"}
                    >
                        <option value="" disabled>Select Driver License State</option>
                        {driverLicenseState.map((item) => (
                            <option key={item.value} value={item.value}>{item.label}</option>
                        ))}
                    </Select>
                    {errors.driverLicenseState && (
                        <span style={{ color: 'red', fontSize: '0.875rem', fontFamily: 'Poppins' }}>
                            {errors.driverLicenseState}
                        </span>
                    )}
                </FormControl>

                <FormControl fullWidth margin="normal" sx={formControlStyle}>
                    <FormLabel sx={{ color: 'black', fontWeight: '500', fontFamily: 'Poppins' }}>Student Type<span style={{ color: 'red' }}>*</span></FormLabel>
                    <Select
                        native
                        name="studentType"
                        value={formData.studentType}
                        onChange={(e) => {
                            handleInputChange(e);
                            if (errors.studentType) {
                                setErrors({ ...errors, studentType: '' });
                            }
                        }}
                        displayEmpty
                        inputProps={{ 'aria-label': 'Student Type' }}
                        sx={{ fontFamily: 'Poppins' }}
                        error={!!errors?.studentType}
                        size={isMobile ? "small" : "medium"}
                    >
                        <option value="" disabled>Select Student Type</option>
                        <option value="Full-Time">Full-Time</option>
                        <option value="Part-Time">Part-Time</option>
                        <option value="Not a Student">Not a Student</option>
                    </Select>
                    {errors?.studentType && (
                        <span style={{ color: 'red', fontSize: '0.875rem', fontFamily: 'Poppins' }}>
                            {errors.studentType}
                        </span>
                    )}
                </FormControl>

                <FormControl fullWidth margin="normal" sx={formControlStyle}>
                    <FormLabel sx={{ color: 'black', fontWeight: '500', fontFamily: 'Poppins' }}>Driver Type<span style={{ color: 'red' }}>*</span></FormLabel>
                    <Select
                        native
                        name="driverType"
                        value={formData.driverType}
                        onChange={(e) => {
                            handleInputChange(e);
                            if (errors.driverType) {
                                setErrors({ ...errors, driverType: '' });
                            }
                        }}
                        displayEmpty
                        error={!!errors.driverType}
                        inputProps={{ 'aria-label': 'Driver Type' }}
                        sx={{ fontFamily: 'Poppins' }}
                        size={isMobile ? "small" : "medium"}
                    >
                        <option value="" disabled>Select Driver Type</option>
                        {driverTypeOptions.map((option) => (
                            <option key={option} value={option}>{option}</option>
                        ))}
                    </Select>
                    {errors.driverType && (
                        <span style={{ color: 'red', fontSize: '0.875rem', fontFamily: 'Poppins' }}>
                            {errors.driverType}
                        </span>
                    )}
                </FormControl>

                <FormControl fullWidth margin="normal" sx={formControlStyle}>
                    <FormLabel sx={{ color: 'black', fontWeight: '500', fontFamily: 'Poppins' }}>Relationship to Policyholder<span style={{ color: 'red' }}>*</span></FormLabel>
                    <Select
                        native
                        name="relationshipToPolicyholder"
                        value={formData.relationshipToPolicyholder}
                        onChange={(e) => {
                            handleInputChange(e);
                            if (errors.relationshipToPolicyholder) {
                                setErrors({ ...errors, relationshipToPolicyholder: '' });
                            }
                        }}
                        displayEmpty
                        error={!!errors.relationshipToPolicyholder}
                        disabled={formData.driverType === 'Insured'}
                        inputProps={{ 'aria-label': 'Relationship to Policyholder' }}
                        sx={{ fontFamily: 'Poppins' }}
                        size={isMobile ? "small" : "medium"}
                    >
                        <option value="" disabled>Select Relationship</option>
                        {relationshipOptions.map((option) => (
                            <option key={option} value={option}>{option}</option>
                        ))}
                    </Select>
                    {errors.relationshipToPolicyholder && (
                        <span style={{ color: 'red', fontSize: '0.875rem', fontFamily: 'Poppins' }}>
                            {errors.relationshipToPolicyholder}
                        </span>
                    )}
                </FormControl>

                <FormControl fullWidth margin="normal" sx={formControlStyle}>
                    <FormLabel sx={{ color: "black", fontWeight: 500, fontFamily: "Poppins" }}>
                        Home
                    </FormLabel>
                    <Select
                        native
                        name="ownedRented"
                        value={
                            formData.ownedRented === "OWNED"
                            ? "Owned"
                            : formData.ownedRented === "RENTED"
                            ? "Rented"
                            : ""
                        }
                        onChange={handleInputChange}
                        displayEmpty
                        inputProps={{ "aria-label": "Home" }}
                        size={isMobile ? "small" : "medium"}
                        >
                        <option value="" disabled>Select</option>
                        <option value="Owned">Owned</option>
                        <option value="Rented">Rented</option>
                        </Select>
                        {errors.ownedRented && (
                        <span style={{ color: "red", fontSize: "0.875rem", fontFamily: "Poppins" }}>
                            {errors.ownedRented}
                        </span>
                        )}
                    </FormControl>

                    <FormControl fullWidth margin="normal" sx={formControlStyle}>
                    <FormLabel sx={{ color: 'black', fontWeight: 500, fontFamily: 'Poppins' }}>
                        Business Owner
                    </FormLabel>
                    <FormControlLabel
                        control={
                        <input
                            type="checkbox"
                            name="businessOwner"
                            checked={!!formData.businessOwner}
                            onChange={handleInputChange}
                            style={{ width: 18, height: 18 }}
                        />
                        }
                        label="Yes, I am a business owner"
                        sx={{ mt: 1, padding: '0 10px' }}
                    />
                    {errors.businessOwner && (
                        <span style={{ color: 'red', fontSize: '0.875rem', fontFamily: 'Poppins' }}>
                        {errors.businessOwner}
                        </span>
                    )}
                </FormControl>

                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'end', marginTop: '20px', gap: 2 }}>
                    <Button
                        variant='outlined' size='large'
                        onClick={() => {
                            setIsLocked(false);
                            setFormData({
                                businessOwner: false,
                                ownedRented: "",       // ← add this
                                homeOwner: null,       // ← add this
                                firstName: "",
                                lastName: "",
                                gender: "",
                                emailId: "",
                                dateOfBirth: dayjs().subtract(16, "year"),
                                address: "",
                                city: "",
                                state: "",
                                zipCode: "",
                                policyNumber: "",
                                company: "",
                                paymentDueDay: null,
                                effectiveDate: null,
                                expirationDate: null,
                                dateLicensed: null,
                                maritalStatus: "",
                                lineOfBusiness: "",
                                policyType: "",
                                phoneNumber: "",
                                priorPolicyNumber: "",
                                residenceMonth: "",
                                residenceYear: "",
                                term: "6",
                                customerId: customerId || null,
                                driverLicenseNumber: "",
                                driverLicenseState: "",
                                studentType: "Not a Student",
                                driverType: "Insured",
                                relationshipToPolicyholder: "Insured",
                                });

                            setErrors({});
                        }}
                            >
                                Reset
                            </Button>
                            <Button variant='contained' size='large' onClick={handleSave}>
                        Save & Continue
                    </Button>
                </Box>
            </Box>

            <Dialog open={openPopup} onClose={() => setOpenPopup(false)} fullWidth maxWidth="md">
                <DialogTitle>Previous Customer Details</DialogTitle>
                    <DialogContent>
                    <p>The following customers were found with matching information:</p>
                    <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell></TableCell>
                                <TableCell><strong>Name</strong></TableCell>
                                <TableCell><strong>Email</strong></TableCell>
                                <TableCell><strong>Phone</strong></TableCell>
                                <TableCell><strong>Date of birth</strong></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {get_saved_customer_list?.content?.map((customer) => (
                            <TableRow
                            key={customer.id}
                            onClick={() => handleRowClick(customer)}
                            style={{
                                background: selectedCustomer?.id === customer.id ? '#d4eaf7' : 'inherit',
                                cursor: 'pointer'
                            }}
                            >
                            <TableCell padding="checkbox">
                                <Radio
                                    checked={selectedCustomer?.id === customer.id}
                                    onChange={() => handleRowClick(customer)}
                                    value={customer.id}
                                    name="customer-selection"
                                    inputProps={{ 'aria-label': customer.firstName }}
                                />
                            </TableCell>
                            <TableCell >{customer.firstName} {customer.lastName}</TableCell>
                            <TableCell>{customer.email}</TableCell>
                            <TableCell>

                                {formatPhoneNumber(customer.phoneNumber)}</TableCell>
                            <TableCell>{parseDob(customer.dateOfBirth)?.format('MM-DD-YYYY') || customer.dateOfBirth}
</TableCell>
                            </TableRow>
                        ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                    <p style={{
                        fontSize: '12px',
                        color: '#000',
                        backgroundColor: '#fff3cd',
                        padding: '6px 10px',
                        borderRadius: '4px'
                    }}>
                    Please Select Row to Confirm Details.
                    </p>
                </DialogContent>
                <DialogActions>
                    <Button
                    onClick={ ()=> {
                        setFormData({ ...formData, clientCustomerId: null });
                        handleClosePopup()}} variant='outlined'>
                        Create New
                    </Button>
                    <Button
                        onClick={handleConfirmSelection}
                        disabled={!selectedCustomer}
                        variant='outlined'
                    >
                        Confirm
                    </Button>
                    <Button
                        onClick={handleClosePopup}
                         variant='outlined'
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={showNameChangeDialog} onClose={() => setShowNameChangeDialog(false)}>
                <DialogTitle>Confirm Name Change</DialogTitle>
                <DialogContent>
                    <p>Changing the {fieldBeingEdited} will create a new customer. Are you sure?</p>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setShowNameChangeDialog(false)} className="btn-secondary">
                        No
                    </Button>
                    <Button
                        onClick={() => {
                            setFormData({ ...formData, clientCustomerId: null });
                            setShowNameChangeDialog(false);
                        }}
                        className="btn-secondary"
                    >
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openConfirmReset}
                onClose={() => setOpenConfirmReset(false)}
                fullWidth
                maxWidth="xs"
                >
                <DialogTitle className="btn-primary"
                    sx={{
                    height: "64px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "0 16px",
                    }}>Reset form?</DialogTitle>
                <DialogContent style={{
                    color: '#000',
                    padding: '15px 20px',
                    }}>
                    You are about to leave this page, but a policy is
                    currently being created. Do you want to stay on this
                    page or reset the form? Resetting will save your changes.
                </DialogContent>
                <DialogActions style={{
                    padding: '15px 20px',
                    }}>
                    <Button
                    onClick={() => setOpenConfirmReset(false)}
                    className="btn-secondary"
                    >
                        Stay
                    </Button>
                    <Button
                        className="btn-secondary"
                        variant="outlined"
                        color="secondary"
                        onClick={resetAndSave}
                        disabled={isResetSaving}
                        sx={{ '&:focus': { outline: '1px solid #E69C00' } }}
                        >
                        {isResetSaving ? 'Saving…' : 'Save & Reset'}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};


export default CreatePolicyForm;